import { IdType } from './common';

export enum InternalNotificationsTypes {
  USER = 'user',
  IN_APP = 'in-app',
}

export enum NotificationType {
  CLOSABLE = 'MD',
  NOT_CLOSABLE = 'NMD',
}

export enum NotificationMessageType {
  NO_INTERNET = 'noInternetConnection',
  EXTERNAL_RESOURCES_FAILED = 'externalResourcesFailed',
}

export interface IInternalNotification {
  id: IdType;
  msg: string;
  msg_type: NotificationType;
  priority: number;
  isInApp?: boolean;
}
